import getAcceptedArtifactFiles from "./getAcceptedArtifactFiles";

export default function isArtifactContentTypeAccepted({ article, artifact }) {
	const acceptedFiles = getAcceptedArtifactFiles(article);

	return Object.keys(acceptedFiles).includes(artifact.contentType);
}
